import React from 'react';

type Props = {
  active: boolean;
  value: number;
  label: string;
  onChange: (value: number | null) => void;
};

const DurationButton = (props: Props) => {
  const toggle = () => {
    props.onChange(props.active ? null : props.value);
  };

  return (
    <button
      className={`flex items-center justify-center px-6 py-2 border rounded-lg hover:border-[#FCB6C0] ${
        props.active
          ? 'bg-[#FEE7EA] text-[#E60A2B] border-[#FCB6C0]'
          : 'text-[#858585] border-[#DEDEDE]'
      }`}
      onClick={toggle}>
      {props.label}
    </button>
  );
};

export default DurationButton;
